module.exports = __webpack_public_path__ + "img/eye-icon.79d7f502.svg";